import { guid, getStore, uncompileStr } from '../config/mUtils';
import {saveClientSideError} from '@/service/common.service'
import AzureStorage from 'azure-storage/browser/azure-storage.blob.export';

export const uploadFileToBlobStorage = (file, containerName, blobStorageSASKey, callback, isCDN = false) => {      
    let uploadResult = {
        isSuccess: false,
        errorMessage: "",
        data: null
    };

    let configStr = getStore("blobStorageConfig");
    if (!configStr){
        uploadResult.errorMessage = "上传设置未配置，请重新登录";
        callback(uploadResult);
        return;
    }

    let configObj = JSON.parse(uncompileStr(configStr));
    let blobStorageURL = "";
    if (isCDN){
        blobStorageURL = "https://" + configObj.CDN;
    }else{
        let blobStorageAccountName = configObj.AccountName;
        let domainName = configObj.DomainName;
        blobStorageURL = "https://" + blobStorageAccountName + domainName;
    }

    if(file == null){
        uploadResult.errorMessage = "请选择要上传的文件";
        callback(uploadResult);
    }

    if(containerName == null || containerName == ""){
        uploadResult.errorMessage = "上传容器未选择";
        callback(uploadResult);
    }

    let fileExtension = file.name.substr(file.name.lastIndexOf('.'));
    let uploadFileName = guid() + fileExtension;

    const blobService = AzureStorage.createBlobServiceWithSas(blobStorageURL, blobStorageSASKey);
    containerName = containerName.toLowerCase();

    var createBlockBlobFromBrowserFile = function(){
        blobService.createBlockBlobFromBrowserFile(containerName, uploadFileName, file, (cbfberror, cres) => {
            if(cbfberror) {
                uploadResult.errorMessage = "文件上传出错" + cbfberror.message;
            } else {
                uploadResult.isSuccess = true;
                uploadResult.data = {
                    originalFile: file,
                    blobFile: cres,
                    uploadFileName: uploadFileName
                };
            }                    
            callback(uploadResult);
        });
    }

    blobService.doesContainerExist(containerName, (exerror, exres) =>{
        if(exerror){
            saveClientSideError("文件上传blob出错", exerror.message);
            uploadResult.errorMessage = "网络错误"; //"容器检查时出错";
            callback(uploadResult);
        }else{
            if(exres.exists){
                createBlockBlobFromBrowserFile();
            }else{
                blobService.createContainer(containerName, (ccerror, result) => {
                    if(ccerror){
                        uploadResult.errorMessage = "创建时容器出错";
                        callback(uploadResult);
                    }else{
                        createBlockBlobFromBrowserFile();
                    }
                });
            }
        }
    });     
}

export const uploadFilesToBlobStorage = (files, containerName, blobStorageSASKey, callback, isCDN = false) => {
    let uploadResult = {
        isSuccess: false,
        errorMessage: "",
        data: []
    };

    let configStr = getStore("blobStorageConfig");
    if (!configStr){
        uploadResult.errorMessage = "上传设置未配置，请重新登录";
        callback(uploadResult);
        return;
    }

    let configObj = JSON.parse(uncompileStr(configStr));

    let blobStorageURL = "";
    if (isCDN){
        blobStorageURL = "https://" + configObj.CDN;
    }else{
        let blobStorageAccountName = configObj.AccountName;
        let domainName = configObj.DomainName;
        blobStorageURL = "https://" + blobStorageAccountName + domainName;
    }
    
    if(!files || !files.length){
        uploadResult.errorMessage = "请选择要上传的文件";
        callback(uploadResult);
    }

    if(containerName == null || containerName == ""){
        uploadResult.errorMessage = "上传容器未选择";
        callback(uploadResult);
    }

    const blobService = AzureStorage.createBlobServiceWithSas(blobStorageURL, blobStorageSASKey);
    containerName = containerName.toLowerCase();

    let createBlockBlobFromBrowserFiles = function() {
        let extFileList = [];
        files.forEach(file => {
            extFileList.push({
                file: file,
                callbackFlag: false
            });
        });

        let isAllSuccess = true;
        let errorMessage = "";
        let dataList = [];
        for (let i = 0; i < extFileList.length; i++) {
            let extFile = extFileList[i];
            let fileExtension = extFile.file.name.substr(extFile.file.name.lastIndexOf('.'));
            let uploadFileName = guid() + fileExtension;

            blobService.createBlockBlobFromBrowserFile(containerName, uploadFileName, extFile.file, (cbfberror, cres) => {
                if(cbfberror) {
                    isAllSuccess = false;
                    errorMessage = "文件上传出错" + cbfberror.message;
                } else {
                    dataList.push({
                        originalFile: extFile.file,
                        blobFile: cres,
                        uploadFileName: uploadFileName
                    });
                }
                extFile.callbackFlag = true;
            });

            if (!isAllSuccess)
                break;
        }

        let callbackReady = function() {
            let isAllFinish = true;
            for (let i = 0; i < extFileList.length; i++) {
                let extFile = extFileList[i];
                if (!extFile.callbackFlag) {
                    isAllFinish = false;
                    break;
                }
            }

            if (isAllFinish) {
                uploadResult.isSuccess = isAllSuccess;
                if (uploadResult.isSuccess)
                    uploadResult.data = dataList;
                else
                    uploadResult.errorMessage = errorMessage;
                callback(uploadResult);
            } else {
                setTimeout(callbackReady, 50);
            }
        }

        callbackReady();
    }

    blobService.doesContainerExist(containerName, (exerror, exres) => {
        if(exerror){
            saveClientSideError("文件上传blob出错", exerror.message);
            uploadResult.errorMessage = "网络错误"; //"容器检查时出错";
            callback(uploadResult);
        }else{
            if(exres.exists){
                createBlockBlobFromBrowserFiles();
            }else{
                blobService.createContainer(containerName, (ccerror, result) => {
                    if(ccerror){
                        uploadResult.errorMessage = "创建时容器出错";
                        callback(uploadResult);
                    }else{
                        createBlockBlobFromBrowserFiles();
                    }
                });
            }
        }
    });    
}



// WEBPACK FOOTER //
// ./src/filters/blobStorage.js